/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Operator for the condition
 */
export type DeviceModelIncidentRuleOperator = (typeof DeviceModelIncidentRuleOperator)[keyof typeof DeviceModelIncidentRuleOperator];

export const DeviceModelIncidentRuleOperator = {
  '=': '=',
  '!=': '!=',
  '>': '>',
  '>=': '>=',
  '<': '<',
  '<=': '<=',
} as const;
